import { render, staticRenderFns } from "./HandsetModal.vue?vue&type=template&id=705ffe60&"
import script from "./HandsetModal.vue?vue&type=script&lang=js&"
export * from "./HandsetModal.vue?vue&type=script&lang=js&"
import style0 from "./HandsetModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports